import { render, staticRenderFns } from "./Payment_advice.vue?vue&type=template&id=d538a87c&"
import script from "./Payment_advice.vue?vue&type=script&lang=js&"
export * from "./Payment_advice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports